import React from 'react';

export const VolEventTsunamiModal = {
  title: 'Tsunami',
  body: (
    <div>
      <p>
        A value would indicate that the volcano caused a tsunami. The link connects to the event associated with the eruption in.
      </p>
    </div>
  ),
};
